<template>
  <div class="success-alert-container">
    <div class="success-alert-wrapper">
      <div class="success-icon-wrapper">
        <icon name="mdi:check-circle" class="success-icon" />
      </div>
      <div class="success-content">
        <p class="success-title">{{ success.title }}</p>
        <p class="success-message">{{ success.message }}</p>
        <span v-if="totalSuccess > 1" class="success-remaining">
          {{ totalSuccess }} restantes
        </span>
      </div>
      <base-button-text
        class="close-btn"
        title="Fechar Alerta"
        @click="() => store.REMOVE_SUCCESS(success)"
      >
        <icon name="mdi:close" class="close-icon" />
      </base-button-text>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  success: {
    title: string;
    message: string;
  },
  totalSuccess: number;
}>();

const store = successStore()

onMounted(() => {
  setTimeout(() => {
    store.REMOVE_SUCCESS(props.success)
  }, 5000);
});
</script>

<style lang="scss" scoped>
.success-alert-container {
  position: fixed;
  right: 32px;
  bottom: 32px;
  z-index: 9999;
  min-width: 320px;
  max-width: 420px;
  width: 100%;
  padding: 0 12px;
  font-family: 'Inter', Arial, sans-serif;
  background: none;
}

.success-alert-wrapper {
  display: flex;
  align-items: center;
  background: #f7faf9;
  border-radius: 14px;
  box-shadow: 0 4px 24px 0 rgba(56, 142, 60, 0.10), 0 1.5px 4px 0 rgba(56, 142, 60, 0.08);
  background: linear-gradient(90deg, #e8f5e9 60%, #b9f6ca 100%);
  padding: 4px 20px;
  border: 1.5px solid #b9f6ca;
  position: relative;
  overflow: hidden;
}

.success-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 50%;
  width: 40px;
  height: 48px;
}

.success-icon {
  font-size: 2.2rem;
  color: #43a047;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  text-align: center;
  min-width: 0;
}

.success-title {
  font-size: 1.13rem;
  font-weight: 700;
  color: #219a6f;
  margin-bottom: 2px;
  line-height: 1.3;
  letter-spacing: 0.01em;
  word-break: break-word;
}

.success-message {
  font-size: 1rem;
  font-weight: 400;
  color: #219a6f;
  margin-top: 0;
  opacity: 0.95;
  word-break: break-word;
}

.success-remaining {
  font-size: 0.95rem;
  color: #219a6f;
  opacity: 0.7;
  margin-top: 4px;
}

.close-btn {
  margin-left: 16px;
  background: none;
  border: none;
  box-shadow: none;
  cursor: pointer;
  align-self: center;
  padding: 0;
  transition: opacity 0.2s;
}

.close-icon {
  font-size: 1.4rem;
  color: #43a047 !important;
  opacity: 0.6;
  transition: opacity 0.2s, color 0.2s;
}

.close-icon:hover {
  opacity: 1;
  color: #2e7d32 !important;
}
</style>
